// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: 3zq-j4IGZ35
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import BtnText from "../../BtnText"; // plasmic-import: R3LXVa6EIz/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicTurnitinModal.module.css"; // plasmic-import: 3zq-j4IGZ35/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: LYoK9OD3Rv/icon

createPlasmicElementProxy;

export const PlasmicTurnitinModal__VariantProps = new Array();

export const PlasmicTurnitinModal__ArgProps = new Array();

const $$ = {};

function PlasmicTurnitinModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__uRcep)}>
        <div className={classNames(projectcss.all, sty.freeBox__ctMp5)}>
          <div className={classNames(projectcss.all, sty.freeBox__p511R)}>
            <div className={classNames(projectcss.all, sty.freeBox__hpzV9)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__eD4Rg
                )}
              >
                {"Turnitin Report"}
              </div>
              <Icon12Icon
                data-plasmic-name={"btnClose"}
                data-plasmic-override={overrides.btnClose}
                className={classNames(projectcss.all, sty.btnClose)}
                role={"img"}
              />
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__h1IK6)}
            >
              <div
                data-plasmic-name={"assessorComment"}
                data-plasmic-override={overrides.assessorComment}
                className={classNames(projectcss.all, sty.assessorComment)}
              />

              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__xNx54)}
              >
                {false ? (
                  <BtnText
                    data-plasmic-name={"btnSubmit"}
                    data-plasmic-override={overrides.btnSubmit}
                    className={classNames("__wab_instance", sty.btnSubmit)}
                    green={true}
                  >
                    {"Submit"}
                  </BtnText>
                ) : null}
                <BtnText
                  data-plasmic-name={"btnCloseBottom"}
                  data-plasmic-override={overrides.btnCloseBottom}
                  className={classNames("__wab_instance", sty.btnCloseBottom)}
                  orange={true}
                >
                  {"Submit"}
                </BtnText>
              </Stack__>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mc8Xp
                )}
              >
                {
                  "The assessment has been submitted, and is ready for release to the moderator. To release the assessment or make changes to your marking, visit the To Be Released section or Return to To Be Marked"
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__i7JnV)}>
                {false ? (
                  <BtnText
                    data-plasmic-name={"btnMark"}
                    data-plasmic-override={overrides.btnMark}
                    className={classNames("__wab_instance", sty.btnMark)}
                    green={true}
                  >
                    {"Submit"}
                  </BtnText>
                ) : null}
                <BtnText
                  data-plasmic-name={"btnRelease"}
                  data-plasmic-override={overrides.btnRelease}
                  className={classNames("__wab_instance", sty.btnRelease)}
                  green={true}
                >
                  {"Submit"}
                </BtnText>
              </div>
              <div
                data-plasmic-name={"loadingSvg2"}
                data-plasmic-override={overrides.loadingSvg2}
                className={classNames(projectcss.all, sty.loadingSvg2)}
              />

              <div className={classNames(projectcss.all, sty.freeBox__eajtc)}>
                <div className={classNames(projectcss.all, sty.freeBox__auxIh)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vm4P2
                    )}
                  >
                    {"Overall SImliarity exceeds 25%"}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__ajf6G)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__wiP1)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__gxOtq)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__iugp6
                        )}
                      >
                        {"Overall  Match"}
                      </div>
                      <div
                        data-plasmic-name={"txtOverall"}
                        data-plasmic-override={overrides.txtOverall}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.txtOverall
                        )}
                      >
                        {" 30%"}
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__eicj)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__edSU
                        )}
                      >
                        {"Internet Match"}
                      </div>
                      <div
                        data-plasmic-name={"txtInternet"}
                        data-plasmic-override={overrides.txtInternet}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.txtInternet
                        )}
                      >
                        {" 10%"}
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox___7KVg)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__tgFeb
                        )}
                      >
                        {"Publication Match"}
                      </div>
                      <div
                        data-plasmic-name={"txtPublication"}
                        data-plasmic-override={overrides.txtPublication}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.txtPublication
                        )}
                      >
                        {" 20%"}
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__dq02T)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__mfbpy
                        )}
                      >
                        {"Submitted Works Match"}
                      </div>
                      <div
                        data-plasmic-name={"txtSubmitted"}
                        data-plasmic-override={overrides.txtSubmitted}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.txtSubmitted
                        )}
                      >
                        {"40%"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__kzw6S
                )}
              >
                {"Please do your own work and resubmit"}
              </div>
              <div
                data-plasmic-name={"btnCloseBottom2"}
                data-plasmic-override={overrides.btnCloseBottom2}
                className={classNames(projectcss.all, sty.btnCloseBottom2)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0QSAx
                  )}
                >
                  {"View Report"}
                </div>
              </div>
              <div
                data-plasmic-name={"btnCloseBottom3"}
                data-plasmic-override={overrides.btnCloseBottom3}
                className={classNames(projectcss.all, sty.btnCloseBottom3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lEzFb
                  )}
                >
                  {"OK"}
                </div>
              </div>
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox___9AG7U)}>
              <div className={classNames(projectcss.all, sty.freeBox__esxRi)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yqjw4
                  )}
                >
                  {"Flags"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__b8OWq)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___57VAh)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__pcVxj)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ouR81
                      )}
                    >
                      {"A -"}
                    </div>
                    <div
                      data-plasmic-name={"txtA"}
                      data-plasmic-override={overrides.txtA}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtA
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__kgiR0)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__phUd8
                      )}
                    >
                      {"S -"}
                    </div>
                    <div
                      data-plasmic-name={"txtS"}
                      data-plasmic-override={overrides.txtS}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtS
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__r0Ta7)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__huiUe
                      )}
                    >
                      {"R -"}
                    </div>
                    <div
                      data-plasmic-name={"txtR"}
                      data-plasmic-override={overrides.txtR}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtR
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__zwd21)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___5Hxq4)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__lrS1T
                      )}
                    >
                      {"B -"}
                    </div>
                    <div
                      data-plasmic-name={"txtB"}
                      data-plasmic-override={overrides.txtB}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtB
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div className={classNames(projectcss.all, sty.freeBox__qFd)}>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__m6Ahy
                      )}
                    >
                      {"C -"}
                    </div>
                    <div
                      data-plasmic-name={"txtC"}
                      data-plasmic-override={overrides.txtC}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtC
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__lz9Mv)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__m36Jq
                      )}
                    >
                      {"P -"}
                    </div>
                    <div
                      data-plasmic-name={"txtP"}
                      data-plasmic-override={overrides.txtP}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtP
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "btnClose",
    "assessorComment",
    "btnSubmit",
    "btnCloseBottom",
    "btnMark",
    "btnRelease",
    "loadingSvg2",
    "txtOverall",
    "txtInternet",
    "txtPublication",
    "txtSubmitted",
    "btnCloseBottom2",
    "btnCloseBottom3",
    "txtA",
    "txtS",
    "txtR",
    "txtB",
    "txtC",
    "txtP"
  ],

  btnClose: ["btnClose"],
  assessorComment: ["assessorComment"],
  btnSubmit: ["btnSubmit"],
  btnCloseBottom: ["btnCloseBottom"],
  btnMark: ["btnMark"],
  btnRelease: ["btnRelease"],
  loadingSvg2: ["loadingSvg2"],
  txtOverall: ["txtOverall"],
  txtInternet: ["txtInternet"],
  txtPublication: ["txtPublication"],
  txtSubmitted: ["txtSubmitted"],
  btnCloseBottom2: ["btnCloseBottom2"],
  btnCloseBottom3: ["btnCloseBottom3"],
  txtA: ["txtA"],
  txtS: ["txtS"],
  txtR: ["txtR"],
  txtB: ["txtB"],
  txtC: ["txtC"],
  txtP: ["txtP"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTurnitinModal__ArgProps,
          internalVariantPropNames: PlasmicTurnitinModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTurnitinModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTurnitinModal";
  } else {
    func.displayName = `PlasmicTurnitinModal.${nodeName}`;
  }
  return func;
}

export const PlasmicTurnitinModal = Object.assign(
  // Top-level PlasmicTurnitinModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    btnClose: makeNodeComponent("btnClose"),
    assessorComment: makeNodeComponent("assessorComment"),
    btnSubmit: makeNodeComponent("btnSubmit"),
    btnCloseBottom: makeNodeComponent("btnCloseBottom"),
    btnMark: makeNodeComponent("btnMark"),
    btnRelease: makeNodeComponent("btnRelease"),
    loadingSvg2: makeNodeComponent("loadingSvg2"),
    txtOverall: makeNodeComponent("txtOverall"),
    txtInternet: makeNodeComponent("txtInternet"),
    txtPublication: makeNodeComponent("txtPublication"),
    txtSubmitted: makeNodeComponent("txtSubmitted"),
    btnCloseBottom2: makeNodeComponent("btnCloseBottom2"),
    btnCloseBottom3: makeNodeComponent("btnCloseBottom3"),
    txtA: makeNodeComponent("txtA"),
    txtS: makeNodeComponent("txtS"),
    txtR: makeNodeComponent("txtR"),
    txtB: makeNodeComponent("txtB"),
    txtC: makeNodeComponent("txtC"),
    txtP: makeNodeComponent("txtP"),
    // Metadata about props expected for PlasmicTurnitinModal
    internalVariantProps: PlasmicTurnitinModal__VariantProps,
    internalArgProps: PlasmicTurnitinModal__ArgProps
  }
);

export default PlasmicTurnitinModal;
/* prettier-ignore-end */
